import { downloadFromBlobUrl } from "../../../../../common/utils/download_utils";
import { IDownloadRequisicaoCompraArquivoUseCase } from "../../../presentation/useCases/read/download_requisicao_compra_arquivo_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DownloadRequisicaoCompraArquivoUseCase
 */

export class DownloadRequisicaoCompraArquivoUseCase implements IDownloadRequisicaoCompraArquivoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async downloadRequisicaoCompraArquivo(
    idRequisicaoCompra: number,
    nroArquivo: number,
    nomeArquivo: string,
  ): Promise<void> {
    const result = await this.repository.downloadRequisicaoCompraArquivo(idRequisicaoCompra, nroArquivo);
    await downloadFromBlobUrl(result, nomeArquivo);
  }
}